/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Video {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Content as ContentModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"

const Content = ({
  subtitle,
  title,
  suptitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  text,
}) => {
  if (!text) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <ContentModule>{parse(text)}</ContentModule>
    </Section>
  )
}

export const query = graphql`
  fragment ContentModuleFragment on ContentModule {
    text
  }
`

export { Content }
